import { Outlet } from 'react-router';

import styles from './styles.module.scss';

export const LayoutContainer = () => {
	return (
		<div className={styles.layoutContainer}>
			<div className={styles.layoutContainer__inner}>
				<Outlet />
			</div>
		</div>
	);
};
